// OP1WebFrameWindowControl (pilot): a tiny BEHAVIOUR piece. Drop it inside the
// header slot of an OP1WebFrameWindow and it closes or minimizes that window
// when clicked. It has no look of its own beyond a neutral reset: put any
// icon / text in its slot and style it freely in Studio.
//
// It finds its window through context, so there's no window id to set.
import React from "react";
import { useDesktopState } from "./DesktopStateProvider";
import { useFrameWindow } from "./OP1WebFrameWindowContext";
import styles from "./OP1WebFrameWindowControl.module.css";

export const CONTROL_ACTIONS = ["close", "minimize"];

const FALLBACK_LABEL = { close: "×", minimize: "–" };

const OP1WebFrameWindowControl = React.forwardRef(
  function OP1WebFrameWindowControl({ action = "close", className, children }, ref) {
    const { actions } = useDesktopState();
    const { windowId } = useFrameWindow();

    const handleClick = (event) => {
      event.stopPropagation();
      if (!windowId) return;
      if (action === "minimize") actions.minimizeWindow(windowId);
      else actions.closeWindow(windowId);
    };

    return (
      <button
        ref={ref}
        type="button"
        data-no-drag=""
        aria-label={action === "minimize" ? "Minimize" : "Close"}
        className={[styles.control, className].filter(Boolean).join(" ")}
        // Keeps the header's drag handler from grabbing this click.
        onPointerDown={(event) => event.stopPropagation()}
        onClick={handleClick}
      >
        {children ?? FALLBACK_LABEL[action]}
      </button>
    );
  }
);

export default OP1WebFrameWindowControl;
